import React from "react";
import SettingsIcon from "@material-ui/icons/Tune";

// Header "Visão geral" + 3 selects (conexão / atendente / período) + engrenagem.
const Header = ({
  V,
  connections,
  attendants,
  connFilter,
  setConnFilter,
  agFilter,
  setAgFilter,
  period,
  setPeriod,
  onOpenSettings,
}) => {
  const selStyle = {
    background: V.selectBg,
    border: V.selectBorder,
    borderRadius: V.selectRadius,
    padding: "8px 12px",
    fontSize: 12,
    fontWeight: V.selectWeight,
    fontFamily: "inherit",
    color: V.selectColor,
    cursor: "pointer",
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 20, fontWeight: 900, color: V.textStrong }}>
          Visão geral
        </div>
        <div style={{ fontSize: 12, color: V.sublabel, marginTop: 1 }}>
          Atendimento e funil de vendas · atualizado agora
        </div>
      </div>

      <select
        value={connFilter}
        onChange={(e) => setConnFilter(e.target.value)}
        style={selStyle}
      >
        <option value="">Todas as conexões</option>
        {connections.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>

      <select
        value={agFilter}
        onChange={(e) => setAgFilter(e.target.value)}
        style={selStyle}
      >
        <option value="">Todos os atendentes</option>
        {attendants.map((a) => (
          <option key={a.id} value={a.id}>
            {a.name}
          </option>
        ))}
      </select>

      <select
        value={period}
        onChange={(e) => setPeriod(e.target.value)}
        style={selStyle}
      >
        <option value="sete">Últimos 7 dias</option>
        <option value="hoje">Hoje</option>
      </select>

      <button
        type="button"
        onClick={(e) =>
          onOpenSettings({
            top: e.currentTarget.getBoundingClientRect().bottom + 4,
            left: e.currentTarget.getBoundingClientRect().right,
          })
        }
        title="Aparência"
        style={{
          border: V.selectBorder,
          background: V.selectBg,
          borderRadius: V.selectRadius,
          width: 34,
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          color: V.selectColor,
          flex: "none",
        }}
      >
        <SettingsIcon style={{ fontSize: 18 }} />
      </button>
    </div>
  );
};

export default Header;
